var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _FiltersView_instances, _FiltersView_filtersData, _FiltersView_categoryLabels, _FiltersView_element, _FiltersView_sectionsContainerElement, _FiltersView_applyButtonElement, _FiltersView_clearButtonElement, _FiltersView_sectionTemplateElement, _FiltersView_listTemplateElement, _FiltersView_checkboxOptionTemplateElement, _FiltersView_radioOptionTemplateElement, _FiltersView_pillOptionTemplateElement, _FiltersView_pillOptionStarTemplateElement, _FiltersView_init, _FiltersView_renderSections, _FiltersView_renderSection, _FiltersView_renderOptionsList, _FiltersView_renderOption, _FiltersView_getOptionTemplateElement, _FiltersView_initSectionToggles, _FiltersView_initEvents, _FiltersView_getState;
import Emitter from '@helpers/Emitter';
import Toggle from '@resources/js/ui/Toggle';
import { FILTER_CATEGORIES_CONFIG } from '@resources/js/components/filters/filterCategoriesConfig';
import { FILTERS_VIEW_EVENTS } from '@resources/js/components/filters/filterEvents';
import { parseCategoryLabels } from '@resources/js/components/filters/helpers';
const SECTION_TOGGLE_VISIBLE_COUNT = 6;
const SECTION_TOGGLE_SELECTOR = '.js-filters-section-toggle';
const SECTION_TOGGLE_TRIGGER_SELECTOR = '.js-filters-section-toggle-trigger';
const FILTER_CATEGORY_ATTRIBUTE = 'data-filter-category';
const FILTER_INPUT_SELECTOR = '.js-filter-input';
const TEMPLATE_IDS = {
    sectionTemplateElement: 'filters-section-template',
    listTemplateElement: 'filters-list-template',
    checkboxOptionTemplateElement: 'filters-checkbox-option-template',
    radioOptionTemplateElement: 'filters-radio-option-template',
    pillOptionTemplateElement: 'filters-pill-option-template',
    pillOptionStarTemplateElement: 'filters-pill-option-star-template',
};
const CATEGORY_LABELS_ELEMENT_ID = 'filters-category-labels';
class FiltersView extends Emitter {
    constructor(filtersData, containerElement) {
        super();
        _FiltersView_instances.add(this);
        _FiltersView_filtersData.set(this, void 0);
        _FiltersView_categoryLabels.set(this, void 0);
        _FiltersView_element.set(this, void 0);
        _FiltersView_sectionsContainerElement.set(this, void 0);
        _FiltersView_applyButtonElement.set(this, void 0);
        _FiltersView_clearButtonElement.set(this, void 0);
        _FiltersView_sectionTemplateElement.set(this, void 0);
        _FiltersView_listTemplateElement.set(this, void 0);
        _FiltersView_checkboxOptionTemplateElement.set(this, void 0);
        _FiltersView_radioOptionTemplateElement.set(this, void 0);
        _FiltersView_pillOptionTemplateElement.set(this, void 0);
        _FiltersView_pillOptionStarTemplateElement.set(this, void 0);
        __classPrivateFieldSet(this, _FiltersView_filtersData, filtersData, "f");
        __classPrivateFieldSet(this, _FiltersView_element, containerElement, "f");
        if (!__classPrivateFieldGet(this, _FiltersView_element, "f"))
            throw new Error('Filters container not found');
        __classPrivateFieldSet(this, _FiltersView_categoryLabels, parseCategoryLabels(CATEGORY_LABELS_ELEMENT_ID), "f");
        __classPrivateFieldSet(this, _FiltersView_sectionsContainerElement, containerElement.querySelector('.js-filters-sections'), "f");
        __classPrivateFieldSet(this, _FiltersView_sectionTemplateElement, document.getElementById(TEMPLATE_IDS.sectionTemplateElement), "f");
        __classPrivateFieldSet(this, _FiltersView_listTemplateElement, document.getElementById(TEMPLATE_IDS.listTemplateElement), "f");
        __classPrivateFieldSet(this, _FiltersView_checkboxOptionTemplateElement, document.getElementById(TEMPLATE_IDS.checkboxOptionTemplateElement), "f");
        __classPrivateFieldSet(this, _FiltersView_radioOptionTemplateElement, document.getElementById(TEMPLATE_IDS.radioOptionTemplateElement), "f");
        __classPrivateFieldSet(this, _FiltersView_pillOptionTemplateElement, document.getElementById(TEMPLATE_IDS.pillOptionTemplateElement), "f");
        __classPrivateFieldSet(this, _FiltersView_pillOptionStarTemplateElement, document.getElementById(TEMPLATE_IDS.pillOptionStarTemplateElement), "f");
        __classPrivateFieldSet(this, _FiltersView_applyButtonElement, __classPrivateFieldGet(this, _FiltersView_element, "f").querySelector('.js-search-filters-apply'), "f");
        __classPrivateFieldSet(this, _FiltersView_clearButtonElement, __classPrivateFieldGet(this, _FiltersView_element, "f").querySelector('.js-search-filters-clear'), "f");
        __classPrivateFieldGet(this, _FiltersView_instances, "m", _FiltersView_init).call(this);
    }
    update(changes) {
        var _a;
        for (const category in changes) {
            const sectionElement = __classPrivateFieldGet(this, _FiltersView_sectionsContainerElement, "f").querySelector(`[${FILTER_CATEGORY_ATTRIBUTE}="${category}"]`);
            if (!sectionElement)
                continue;
            const values = (_a = changes[category]) !== null && _a !== void 0 ? _a : [];
            const inputElements = sectionElement.querySelectorAll(FILTER_INPUT_SELECTOR);
            inputElements.forEach(inputElement => {
                inputElement.checked = values.includes(Number(inputElement.value));
            });
        }
    }
    clear() {
        const inputElements = __classPrivateFieldGet(this, _FiltersView_sectionsContainerElement, "f").querySelectorAll(FILTER_INPUT_SELECTOR);
        inputElements.forEach(inputElement => {
            inputElement.checked = false;
        });
    }
}
_FiltersView_filtersData = new WeakMap(), _FiltersView_categoryLabels = new WeakMap(), _FiltersView_element = new WeakMap(), _FiltersView_sectionsContainerElement = new WeakMap(), _FiltersView_applyButtonElement = new WeakMap(), _FiltersView_clearButtonElement = new WeakMap(), _FiltersView_sectionTemplateElement = new WeakMap(), _FiltersView_listTemplateElement = new WeakMap(), _FiltersView_checkboxOptionTemplateElement = new WeakMap(), _FiltersView_radioOptionTemplateElement = new WeakMap(), _FiltersView_pillOptionTemplateElement = new WeakMap(), _FiltersView_pillOptionStarTemplateElement = new WeakMap(), _FiltersView_instances = new WeakSet(), _FiltersView_init = function _FiltersView_init() {
    __classPrivateFieldGet(this, _FiltersView_instances, "m", _FiltersView_renderSections).call(this);
    __classPrivateFieldGet(this, _FiltersView_instances, "m", _FiltersView_initSectionToggles).call(this);
    __classPrivateFieldGet(this, _FiltersView_instances, "m", _FiltersView_initEvents).call(this);
}, _FiltersView_renderSections = function _FiltersView_renderSections() {
    // порядок секцій — за ключами FILTER_CATEGORIES_CONFIG,
    // не за порядком, у якому категорії прийшли з checkAvail.filters
    for (const category of Object.keys(FILTER_CATEGORIES_CONFIG)) {
        const options = __classPrivateFieldGet(this, _FiltersView_filtersData, "f")[category];
        if (!(options === null || options === void 0 ? void 0 : options.length))
            continue;
        __classPrivateFieldGet(this, _FiltersView_sectionsContainerElement, "f").append(__classPrivateFieldGet(this, _FiltersView_instances, "m", _FiltersView_renderSection).call(this, category, options));
    }
}, _FiltersView_renderSection = function _FiltersView_renderSection(category, options) {
    var _a;
    const sectionElement = __classPrivateFieldGet(this, _FiltersView_sectionTemplateElement, "f").content.firstElementChild.cloneNode(true);
    sectionElement.dataset.filterCategory = category;
    const titleElement = sectionElement.querySelector('.js-filter-section-title');
    titleElement.textContent = (_a = __classPrivateFieldGet(this, _FiltersView_categoryLabels, "f")[category]) !== null && _a !== void 0 ? _a : category;
    const config = FILTER_CATEGORIES_CONFIG[category];
    const bodyElement = sectionElement.querySelector('.js-filters-section-body');
    const listElement = __classPrivateFieldGet(this, _FiltersView_instances, "m", _FiltersView_renderOptionsList).call(this, category, options, config);
    bodyElement.append(listElement);
    const canToggle = config.controlType !== 'radio';
    const needsToggle = canToggle && options.length > SECTION_TOGGLE_VISIBLE_COUNT;
    if (!needsToggle) {
        const moreButtonElement = sectionElement.querySelector(SECTION_TOGGLE_TRIGGER_SELECTOR);
        moreButtonElement.remove();
    }
    return sectionElement;
}, _FiltersView_renderOptionsList = function _FiltersView_renderOptionsList(category, options, config) {
    const listElement = __classPrivateFieldGet(this, _FiltersView_listTemplateElement, "f").content.firstElementChild.cloneNode(true);
    if (config.layout)
        listElement.classList.add(`${listElement.className}--${config.layout}`);
    const groupName = `search-filters-${category}`;
    options.forEach((option, index) => {
        const optionElement = __classPrivateFieldGet(this, _FiltersView_instances, "m", _FiltersView_renderOption).call(this, option, category, config, groupName);
        if (index >= SECTION_TOGGLE_VISIBLE_COUNT)
            optionElement.classList.add('hideable');
        listElement.append(optionElement);
    });
    return listElement;
}, _FiltersView_renderOption = function _FiltersView_renderOption(option, category, config, groupName) {
    const templateElement = __classPrivateFieldGet(this, _FiltersView_instances, "m", _FiltersView_getOptionTemplateElement).call(this, category, config);
    const optionElement = templateElement.content.firstElementChild.cloneNode(true);
    const inputElement = optionElement.querySelector(FILTER_INPUT_SELECTOR);
    inputElement.name = groupName;
    inputElement.value = String(option.id);
    const textElement = optionElement.querySelector('.js-filter-option-text');
    textElement.textContent = option.name;
    // TODO: узгодити і за потреби додати іконки
    return optionElement;
}, _FiltersView_getOptionTemplateElement = function _FiltersView_getOptionTemplateElement(category, config) {
    if (config.controlType === 'radio')
        return __classPrivateFieldGet(this, _FiltersView_radioOptionTemplateElement, "f");
    if (config.controlType === 'pills') {
        return category === 'stars'
            ? __classPrivateFieldGet(this, _FiltersView_pillOptionStarTemplateElement, "f")
            : __classPrivateFieldGet(this, _FiltersView_pillOptionTemplateElement, "f");
    }
    return __classPrivateFieldGet(this, _FiltersView_checkboxOptionTemplateElement, "f");
}, _FiltersView_initSectionToggles = function _FiltersView_initSectionToggles() {
    const sectionElements = __classPrivateFieldGet(this, _FiltersView_sectionsContainerElement, "f").querySelectorAll(SECTION_TOGGLE_SELECTOR);
    sectionElements.forEach(sectionElement => {
        const triggerElement = sectionElement.querySelector(SECTION_TOGGLE_TRIGGER_SELECTOR);
        if (!triggerElement)
            return;
        new Toggle(triggerElement, { target: sectionElement });
    });
}, _FiltersView_initEvents = function _FiltersView_initEvents() {
    __classPrivateFieldGet(this, _FiltersView_applyButtonElement, "f").addEventListener('click', () => {
        this.emit(FILTERS_VIEW_EVENTS.APPLY, __classPrivateFieldGet(this, _FiltersView_instances, "m", _FiltersView_getState).call(this));
    });
    __classPrivateFieldGet(this, _FiltersView_clearButtonElement, "f").addEventListener('click', () => {
        this.clear();
        this.emit(FILTERS_VIEW_EVENTS.CLEAR);
    });
}, _FiltersView_getState = function _FiltersView_getState() {
    const sectionElements = __classPrivateFieldGet(this, _FiltersView_sectionsContainerElement, "f").querySelectorAll(`[${FILTER_CATEGORY_ATTRIBUTE}]`);
    const state = {};
    sectionElements.forEach(sectionElement => {
        const category = sectionElement.dataset.filterCategory;
        if (!category)
            return;
        const checkedInputs = sectionElement.querySelectorAll(`${FILTER_INPUT_SELECTOR}:checked`);
        state[category] = Array.from(checkedInputs).map(input => Number(input.value));
    });
    return state;
};
export default FiltersView;
